export const ANNOUNCEMENT_CATEGORY_NAMES = {
  update: 'アップデート情報',
  'new-feature': '新機能',
  important: '重要',
};
